import React from 'react';
import { motion } from 'framer-motion';
import Icon from './Icon';
import { OrnDivider } from './Ornaments';
import { BENEFITS } from '../../lib/constants';

const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12 } },
};
const item = {
  hidden: { opacity: 0, y: 30 },
  show: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } },
};

const Benefits = () => (
  <section data-testid="benefits-section" className="bg-ivory pt-8 pb-14 md:pt-10 md:pb-20">
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: '-80px' }}
        transition={{ duration: 0.6 }}
        className="text-center"
      >
        <OrnDivider className="mb-5" />
        <h2 className="font-serif text-3xl tracking-tight text-ink md:text-4xl lg:text-5xl">
          Benefits of Sai Baba<br className="hidden md:block" /> Mahotsava Pooja
        </h2>
      </motion.div>

      <motion.div
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '-60px' }}
        className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4"
      >
        {BENEFITS.map((b) => (
          <motion.div
            key={b.title}
            variants={item}
            whileHover={{ y: -8 }}
            transition={{ type: 'spring', stiffness: 300, damping: 20 }}
            data-testid={`benefit-card-${b.title.replace(/\s+/g, '-').toLowerCase()}`}
            className="group rounded-2xl border border-gold/25 bg-white p-8 text-center shadow-[0_20px_50px_-35px_rgba(92,22,22,0.5)] transition-colors hover:border-gold/60"
          >
            <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-gold/40 bg-[radial-gradient(circle_at_50%_35%,#FBF3D8,#FFFFFF)] text-gold-deep transition-transform duration-300 group-hover:scale-110">
              <Icon name={b.icon} className="h-7 w-7" strokeWidth={1.6} />
            </div>
            <h3 className="mt-5 font-serif text-xl text-ink">{b.title}</h3>
            <p className="mt-3 font-sans text-sm leading-relaxed text-ink/65">{b.desc}</p>
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);

export default Benefits;
